<template lang="">
  <div id="content">
    <div class="global_area">
      <div class="path"><a href="#none">Home</a> &gt; <a href="#none">회원 관리</a> &gt; <strong>회원 리스트</strong></div>
      <h2 class="h_sub">회원 리스트</h2>
    </div>

    <AccountManageListForm/>
  </div>
</template>

<script>
import AccountManageListForm from '@/components/admin/account/AccountManageListForm.vue';

export default {
  components: {
    AccountManageListForm
  }
    
}
</script>
<style lang="">
    
</style>